import React from 'react';

interface CircularProgressProps {
  value: number | string;
  size?: number;
  strokeWidth?: number;
}

export const CircularProgress: React.FC<CircularProgressProps> = ({ 
  value, 
  size = 16, 
  strokeWidth = 2 
}) => {
  const numericValue = typeof value === 'number' ? value : parseFloat(String(value).replace('%', ''));
  
  if (isNaN(numericValue)) {
    return <span>{value}</span>;
  }

  const percentage = Math.max(0, Math.min(100, numericValue));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;
  const center = size / 2;

  return (
    <div className="flex items-center gap-2">
      <svg width={size} height={size} className="transform -rotate-90">
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="#E5E7EB"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="#6366F1"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <span className="text-sm font-medium">
        {numericValue.toFixed(2)}%
      </span>
    </div>
  );
};
